import { $wgsl } from "../../wgsl-preprocessor/wgsl-preprocessor";
import vertexTransform from "./vertex_transform.wgsl";

export function getVertexTransformChunk() {
  const av = Autodesk.Viewing;
  const useCameraOffset = av.FeatureFlags.isEnabled(av.Private.InternalFeatureFlags.EnableCameraOffset);
  return $wgsl(vertexTransform, { useCameraOffset });
}